import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './CurrencyConverter.css'; // Adjust the path if necessary


function CurrencyConverter() {
  const [currencies, setCurrencies] = useState([]);
  const [fromCurrency, setFromCurrency] = useState('USD');
  const [toCurrency, setToCurrency] = useState('EUR');
  const [amount, setAmount] = useState(1);
  const [result, setResult] = useState(null);
  const [rates, setRates] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('https://api.exchangerate-api.com/v4/latest/USD');
        setCurrencies(Object.keys(response.data.rates));
        setRates(response.data.rates);
      } catch (error) {
        console.error('Error fetching currency data', error);
      }
    };
    fetchData();
  }, []);

  const handleConvert = () => {
    if (rates[fromCurrency] && rates[toCurrency]) {
      const usdAmount = amount / rates[fromCurrency];
      const converted = usdAmount * rates[toCurrency];
      setResult(converted.toFixed(2));
    }
  };

  return (
    <div className="utility-box">
      <h4>Currency Converter</h4>
      <div className="d-flex mb-2">
        <input
          type="number"
           className="form-control me-2 value-gradient-input"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <select
          className="form-select me-2 custom-select"
          value={fromCurrency}
          onChange={(e) => setFromCurrency(e.target.value)}
        >
          {currencies.map((curr) => (
            <option key={curr} value={curr}>{curr}</option>
          ))}
        </select>
        <span className="mx-2 align-self-center">to</span>
        <select
          className="form-select custom-select"
          value={toCurrency}
          onChange={(e) => setToCurrency(e.target.value)}
        >
          {currencies.map((curr) => (
            <option key={curr} value={curr}>{curr}</option>
          ))}
        </select>
      </div>
      <button className="btn btn-primary" onClick={handleConvert}>Convert</button>
      {result && (
        <div className="mt-3">
          <h5 className="text-warning">Result: {result} {toCurrency}</h5>
        </div>
      )}
    </div>
  );
}

export default CurrencyConverter;
